import _union from 'lodash/union';

import { activityActionTypes } from './constants';

import type { DayData } from '../types';

export interface ActivityState {
	loading: boolean;
	activity: Record<string, DayData[]>;
	startedDate: string;
	playedDays: string[];
	activeDate: Date;
	previousDate: string | null;
	nextDate: string | null;
}

const initialState: ActivityState = {
	loading: false,
	activity: {},
	startedDate: '',
	playedDays: [],
	activeDate: new Date(),
	previousDate: null,
	nextDate: null,
};

export default function activityReducer(
	state = initialState,
	action: { type: string; payload?: Partial<ActivityState> },
): ActivityState {
	const { type, payload } = action;
	const { activeDate, activity, startedDate, playedDays, previousDate, nextDate } = payload || {};

	switch (type) {
		case activityActionTypes.GET_REPORT_ACTIVITY_REQUEST:
			return {
				...state,
				loading: true,
			};

		case activityActionTypes.GET_REPORT_ACTIVITY_SUCCESS:
			return {
				...state,
				loading: false,
				activity: activity as Record<string, DayData[]>,
				startedDate: startedDate as string,
			};

		case activityActionTypes.GET_REPORT_ACTIVITY_ERROR:
			return {
				...state,
				loading: false,
			};

		case activityActionTypes.GET_PLAYED_DAYS_SUCCESS:
			return {
				...state,
				playedDays: _union(playedDays, state.playedDays),
			};

		case activityActionTypes.SET_ACTIVE_DATE:
			return {
				...state,
				activeDate: activeDate as Date,
			};

		case activityActionTypes.SET_PREVIOUS_DATE:
			return {
				...state,
				previousDate: previousDate as string | null,
			};

		case activityActionTypes.SET_NEXT_DATE:
			return {
				...state,
				nextDate: nextDate as string | null,
			};

		default:
			return state;
	}
}
